export function scrollToShake(
	id: string,
	options?: { checkOffscreen?: boolean },
) {
	const { checkOffscreen } = {
		checkOffscreen: true,
		...(options ?? {}),
	};

	const element = document.getElementById(id);
	if (!element || element.classList.contains('shake')) return;

	const canApply = checkOffscreen
		? element.getBoundingClientRect().y > window.innerHeight
		: true;

	if (canApply) {
		element.classList.add('shake');
		element.scrollIntoView({
			behavior: 'smooth',
			block: 'start',
			inline: 'start',
		});

		setTimeout(() => {
			element.classList.remove('shake');
		}, 1500);
	}
}
